import React, { Component, useEffect, useState } from "react";
import { Table, Tag, Space } from "antd";
import { IN_PROGRESS } from "../state/constants/actions";
import EmptyState from "./TWComponents/EmptyState";
import voucher from "../images/icons/voucher.svg";

export default function AccountMyVoucher({ data, langData, uiState, locale }) {
  const columns = [
    {
      title: langData.title_redemption_date,
      dataIndex: "redemption_date",
      key: "redemption_date",
      fixed: true,
      width: "12%",
    },
    {
      title: langData.title_voucher_code,
      dataIndex: "voucher_code",
      key: "voucher_code",
      width: "12%",
    },
    {
      title: langData.title_category,
      dataIndex: "category",
      key: "category",
      width: "17%",
    },
    {
      title: langData.title_voucher_name,
      dataIndex: "voucher_name",
      key: "voucher_name",
      width: "29%",
    },
    {
      title: langData.title_point_redeemed,
      dataIndex: "point_redeemed",
      key: "point_redeemed",
      width: "10%",
    },
    {
      title: langData.title_voucher_expiry,
      dataIndex: "voucher_expiry",
      key: "voucher_expiry",
      width: "12%",
    },
    {
      title: langData.title_status,
      dataIndex: "status",
      key: "status",
      width: "8%",
    },
  ];

  const [result, setResult] = useState([]);

  useEffect(() => {
    dataTabel();
  }, [data]);

  const dataTabel = () => {
    let obj = [];
    if (process.env.GATSBY_ENABLE_AUTH0 !== "true") {
      if (data.data !== undefined) {
        data.data.map(function (val, index) {
          obj[index] = {
            redemption_date: val.redemption_date,
            voucher_code: val.voucher_number,
            category: val.category,
            voucher_name: val.voucher_name,
            point_redeemed: val.point_redeemed.toLocaleString(undefined, {
              maximumFractionDigits: 0,
            }),
            voucher_expiry: val.voucher_expiry,
            status: val.status,
          };
        });
      }
    }

    if (process.env.GATSBY_ENABLE_AUTH0 === "true") {
      if (data !== undefined) {
        data.map(function (val, index) {
          obj[index] = {
            redemption_date: val.redemptionDate,
            voucher_code: val.voucherNumber,
            category: val.category,
            voucher_name: val.voucherName,
            point_redeemed: val.pointRedeemed.toLocaleString(undefined, {
              maximumFractionDigits: 0,
            }),
            voucher_expiry: val.voucherExpiry,
            status: val.status,
          };
        });
      }
    }

    setResult(obj);
  };

  return result.length == 0 && uiState !== IN_PROGRESS ? (
    <EmptyState
      icon={voucher}
      buttonTitle={langData.button_title}
      description={langData.description}
      tab={"voucher"}
      locale={locale}
    />
  ) : (
    <Table
      size="small"
      scroll={{ x: 1100 }}
      columns={columns}
      loading={uiState === IN_PROGRESS ? true : false}
      dataSource={result}
      bordered={true}
      pagination={false}
    />
  );
}
